export default "__VITE_ASSET__6a7362c5__"